import { render, staticRenderFns } from "./KillMatrix.vue?vue&type=template&id=5e79dded&scoped=true&"
import script from "./KillMatrix.vue?vue&type=script&lang=js&"
export * from "./KillMatrix.vue?vue&type=script&lang=js&"
import style0 from "./KillMatrix.vue?vue&type=style&index=0&id=5e79dded&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e79dded",
  null
  
)

export default component.exports